import { render } from "./FolderGradeForm.vue?vue&type=template&id=3228e2a6"
import script from "./FolderGradeForm.vue?vue&type=script&lang=js"
export * from "./FolderGradeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__